export default {
  path: '/',
  params: {} as Record<string, string>,
  query: {} as Record<string, string>,
  type: 'transfer',
  unSavedForm: false,
  isMobileTransfer: false,
  nextRoute: null,
  isPanelOpen: false,
  isPanelHalfOpen: false,
  isPanelFullOpen: false,
  name: '',
};
